export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione di un assegno elettronico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conto di accredito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di attivazione"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifica"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
}